import { useTranslator } from "@eo-locale/react";

import { useRouter } from "next/router";

import { useContext, useRef, memo } from "react";

import { AiOutlineInfo } from "react-icons/ai";

import {
  Box,
  FiList,
  FiMapPin,
  FiShare2,
  IconButton,
  SocialShare,
  useMediaQuery
} from "@/storybook-components";
import FilterPinModal from "../filter-pin-modal";
import useAccessStatus from "@/hooks/places/use-access-status";
import { useAppSelector } from "@/redux/store/hooks";

import { EsriContext } from "../../context/esri-context";
import { EsriContextType } from "../../context/esri-context-type";

const MobileInteractions = ({
  handleDropPinMobile,
  handleActivityFeedClick,
  activityFeedProps
}) => {
  const { accessStatus } = useAccessStatus();
  const { settings } = useAppSelector((state) => state.settings);
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const { translate } = useTranslator();
  const { baseUrl } = useAppSelector((state) => state.adapter.adapter);
  const toolName = useAppSelector((state) => state.place.place.name);
  const place = useAppSelector((state) => state?.place?.place);
  const { state: placesState } = place || {};
  const { state: projectState } = useAppSelector(
    (state) => state.project.project
  );
  const isToolArchived = placesState === "archived";
  const isProjectArchived = projectState === "archived";
  const overAllStatus = isProjectArchived || isToolArchived;
  const {
    query: { projectId, placesId }
  } = useRouter();
  const btnRef = useRef(null);

  const { openInfoModal } = useContext(EsriContext) as EsriContextType;

  return (
    <Box
      position={"fixed"}
      bottom="0"
      right={"-0.4375rem"}
      left={"-0.4375rem"}
      width="100%"
      marginBottom="1.5rem !important"
      justifyContent={"space-evenly"}
      alignItems={"left"}
      display={{ base: "auto", lg: "none", sm: "flex" }}
      gap={overAllStatus ? 6 : 1}
    >
      <Box>
        <IconButton
          ref={btnRef}
          size="lg"
          boxShadow="lg"
          variant="solid"
          borderRadius="50%"
          bg="white"
          color="gray.900"
          fontSize="20px"
          _hover={{ background: "gray.100", color: "gray.900" }}
          onClick={openInfoModal}
          icon={<AiOutlineInfo />}
          aria-label={translate("places.infoIcon")}
        />
      </Box>
      <Box>
        {!settings.disableSocialMediaSharing && (
          <SocialShare
            placement={isMobile ? "auto-end" : "auto"}
            trigger={
              <IconButton
                size="lg"
                boxShadow="lg"
                variant="solid"
                borderRadius="50%"
                bg="white"
                color="gray.900"
                _hover={{ background: "gray.100", color: "gray.900" }}
                icon={<FiShare2 />}
                aria-label={translate("places.shareAriaLabel")}
              />
            }
            title={toolName}
            shareUrl={`${baseUrl}/${projectId}/places/${placesId}`}
          />
        )}
      </Box>
      <Box>
        <FilterPinModal />
      </Box>
      <Box>
        <IconButton
          icon={<FiList />}
          aria-label={translate("places.feed")}
          {...activityFeedProps}
          onClick={() => handleActivityFeedClick()}
        />
      </Box>
      {accessStatus ? (
        <Box>
          <IconButton
            size="lg"
            boxShadow="lg"
            borderRadius="50%"
            variant="primary"
            onClick={handleDropPinMobile}
            icon={<FiMapPin />}
            aria-label={translate("places.pin.new")}
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default memo(MobileInteractions);
